import { useMemo, useState } from "react";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import routes from "routes";
import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";

function flattenRoutes(nodes, acc = []) {
  nodes?.forEach((r) => {
    if (r?.route && r?.component && !r?.hidden) {
      acc.push({
        name: r.name ?? "",
        key: r.key ?? "",
        route: r.route ?? "",
        title: r.headerTitle ?? r.name ?? "",
        subtitle: r.subtitle ?? "",
        obs: r.obs ?? "",
      });
    }
    if (Array.isArray(r?.collapse)) flattenRoutes(r.collapse, acc);
  });
  return acc;
}

export default function SeedMenusFromRoutes() {
  const { showAlert } = useAlert();
  const [busy, setBusy] = useState(false);
  const flat = useMemo(() => flattenRoutes(routes), []);

  const syncNow = async () => {
    setBusy(true);
    let ok = 0,
      fail = 0;
    for (const it of flat) {
      const [, err] = await handleApi(api.post("Administracao/menus/upsert", it));
      if (err) fail++;
      else ok++;
    }
    setBusy(false);
    showAlert(`Sincronização concluída. ${ok} ok, ${fail} falhas.`, fail ? "warning" : "success");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {busy && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}
      <MDBox px={2} mt={2} pb={3}>
        <Card>
          <MDBox p={3} display="flex" alignItems="center" justifyContent="space-between">
            <div>
              <MDTypography variant="h5">Sincronizar menus a partir de routes</MDTypography>
              <MDTypography variant="button" color="text">
                Encontrados {flat.length} itens com rota.
              </MDTypography>
            </div>
            <MDButton color="info" onClick={syncNow} disabled={busy}>
              Sincronizar
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
